/**
 * Encode in-memory telemetry samples to BrakeAce / BYB TELEMETRY-V3 binary (.byb).
 * Mirrors `scripts/convert-csv-to-byb.mjs` (browser-safe, no Node Buffer).
 */

const MAGIC = 'TELEMETRY-V3';
export const BYB_HEADER_SIZE = 0xfc;
const FRAME_SIZE = 52;
const BYB_SAMPLE_RATE_HZ = 1000;

const DEFAULT_LABEL_WORDS = [0x006f, 0x0072, 0x0062, 0x005a, 0x0059, 0x005e];
const BYB_NOTES_TEMPLATE_BASE64 = 'T4cCAAsCJAduAHQAZABdAFsAYQDaAYEMe/lb/isBHAAIf4IVWSK8zQCArUNLWW5B8PAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAAAAAAAAAAAAEAAAAAAAAAoAn7AQBgAAAA+KoBAGAyMTAAAAAAAAAAODAAAAAAAADhCDAAAAAAAAAA4QgwAAAAAAAAAOEIMjAwAAAAAAAAADc1AAAAAAAA4QgwAAAAAAAAAOEIMAAAAAAAAADhCDIwMAAAAAAAAAAyMjQAAAAAAAAAMAAAAAAAAADhCDAAAAAAAAAA4QgyOQAAAAAAAOEIMjcuNQAAAAAAADAAAAAAAAAA4QgwAAAAAAAAAOEIMAAAAAAAAAABADAAAAAAAAAA4QhhRfj/HQH//////////wBcpAQAYDAAAAAAAAAA4QhhRfj/HQH//////////wBcpAQAYDAAAAAAAAAA4QhhRfj/HQH//////////wBcpAQAYDAAAAAAAAAA4QhhRfj/HQH//////////wBcpAQAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAAAAAAAAAAAQAAAAAAAACgCfsBAGAAAAD4qgEAYAAA4AAAAAAAAADAKDQ2AQAAALAAAAAAAAAAIKKcAQBgAAAA+KoBAGAAAAEAAAAAAAAAkAWsNAEAAACAkqs0AQAAAAAAAAAAAAAAAQAAAAAAAAAwBaw0AQAAALB8qzQBAAAAAAAAAAAAAAABAAAAAAAAADAFrDQBAAAAkHyrNAEAAAAAAAAAAAAAAAEAAAAAAAAAMAWsNAEAAABwfKs0AQAAAAAAAAAAAAAAAQAAAAAAAAABAAAAAAAAABgAAAAAAAAAAAAAAAAAAAABAAAAAAAAAOWAXU2eC0JAhJ84gH4VVcAAAAAAAAD4fwEAAAAAAAAAJhTHJp4LQkDvyFhtfhVVwAAAAAAAAPh/bPmqAQ==';

const GYRO_SCALE = { x: 0.008691681759940678, y: 0.008394306637262034, z: 0.008766234513816926 };
const GYRO_BIAS = { x: -0.012961327590996335, y: 0.02320646665722675, z: -0.0067190661252827565 };

function pick(row, keys, fallback = '') {
  for (const key of keys) {
    const value = row[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return fallback;
}

function toNumber(v, fallback = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

function clampInt16(v) {
  if (v > 32767) return 32767;
  if (v < -32768) return -32768;
  return Math.round(v);
}

function clampUInt16(v) {
  if (v > 65535) return 65535;
  if (v < 0) return 0;
  return Math.round(v);
}

function clampInt32(v) {
  if (v > 2147483647) return 2147483647;
  if (v < -2147483648) return -2147483648;
  return Math.round(v);
}

function finiteNumber(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/**
 * Flatten a RideView telemetry sample into row keys understood by {@link encodeRowFrame}.
 * Accepts normalized app fields (fork, gyro_x, …) and BYB/CSV-style aliases.
 */
export function telemetrySampleToBybExportRow(sample) {
  if (!sample || typeof sample !== 'object') return {};
  const s = sample;
  return {
    Time: s.time,
    time: s.time,
    Fork: s.fork,
    Shock: s.shock,
    front_disp: s.fork,
    rear_disp: s.shock,
    Susp1: s.fork,
    Susp2: s.shock,
    Fbrake: s.front_brake,
    Rbrake: s.rear_brake,
    Brake1: s.front_brake,
    Brake2: s.rear_brake,
    Speed: s.speed,
    gpsSpeed: s.gps_speed ?? s.speed,
    AccX: s.accel_x,
    AccY: s.accel_y,
    AccZ: s.accel_z,
    GyroX: s.gyro_x,
    GyroY: s.gyro_y,
    GyroZ: s.gyro_z,
    Latitude: s.lat,
    Longitude: s.lon,
    Altitude: s.elevation,
    lat: s.lat,
    lon: s.lon,
  };
}

function writeAscii(view, offset, str, maxLen) {
  const enc = new TextEncoder();
  const buf = enc.encode(str);
  for (let i = 0; i < maxLen; i += 1) {
    view.setUint8(offset + i, i < buf.length ? buf[i] : 0);
  }
}

export function makeBybHeaderBuffer(rows, templateHeaderU8) {
  if (templateHeaderU8 && templateHeaderU8.length >= BYB_HEADER_SIZE) {
    return templateHeaderU8.slice(0, BYB_HEADER_SIZE);
  }
  const header = new Uint8Array(BYB_HEADER_SIZE);
  const view = new DataView(header.buffer);
  writeAscii(view, 0, MAGIC, MAGIC.length);
  writeAscii(view, 0x2c, 'NULL', 4);
  writeAscii(view, 0x58, 'Telemetry', 16);
  writeAscii(view, 0x84, 'MTB', 8);
  writeAscii(view, 0x8e, '1000', 8);
  writeAscii(view, 0x98, 'ANALOG', 8);

  const now = new Date();
  view.setUint16(0xe6, now.getUTCFullYear(), true);
  view.setUint8(0xe8, now.getUTCMonth() + 1);
  view.setUint8(0xe9, now.getUTCDate());
  view.setUint8(0xea, now.getUTCHours());
  view.setUint8(0xeb, now.getUTCMinutes());
  view.setUint8(0xec, now.getUTCSeconds());
  view.setUint8(0xed, 0);

  view.setUint16(0xf0, 0xffff, true);
  view.setUint16(0xf2, 0x8203, true);
  view.setFloat32(0xf4, 1.6151485, true);
  view.setUint16(0xf8, 0xffff, true);

  void rows;
  return header;
}

function resampleRowsToBybRate(rows) {
  if (!Array.isArray(rows) || rows.length < 2) return rows;
  const times = rows.map((row) => finiteNumber(row.time ?? row.Time));
  if (times.some((t) => t == null)) return rows;

  const firstTime = times[0];
  const lastTime = times[times.length - 1];
  const duration = lastTime - firstTime;
  if (!Number.isFinite(duration) || duration <= 0) return rows;

  const inferredRate = (rows.length - 1) / duration;
  if (!Number.isFinite(inferredRate) || inferredRate >= BYB_SAMPLE_RATE_HZ * 0.9) return rows;

  const outputCount = Math.round(duration * BYB_SAMPLE_RATE_HZ) + 1;
  const numericKeys = new Set();
  for (const row of rows) {
    for (const [key, value] of Object.entries(row)) {
      if (finiteNumber(value) != null) numericKeys.add(key);
    }
  }

  const out = [];
  let src = 0;
  for (let i = 0; i < outputCount; i += 1) {
    const t = firstTime + i / BYB_SAMPLE_RATE_HZ;
    while (src + 1 < rows.length && times[src + 1] < t) src += 1;
    const a = rows[src];
    const b = rows[Math.min(src + 1, rows.length - 1)];
    const ta = times[src];
    const tb = times[Math.min(src + 1, rows.length - 1)];
    const span = tb === ta ? 0 : (t - ta) / (tb - ta);
    const row = { ...a, time: t, Time: t };
    for (const key of numericKeys) {
      const av = finiteNumber(a[key]);
      const bv = finiteNumber(b[key]);
      if (av != null && bv != null) row[key] = av + (bv - av) * span;
    }
    out.push(row);
  }
  return out;
}

function writeAsciiBytes(out, offset, text, maxLen) {
  const enc = new TextEncoder();
  const bytes = enc.encode(text);
  for (let i = 0; i < maxLen; i += 1) out[offset + i] = i < bytes.length ? bytes[i] : 0;
}

function writeUInt32LE(out, offset, value) {
  out[offset] = value & 0xff;
  out[offset + 1] = (value >> 8) & 0xff;
  out[offset + 2] = (value >> 16) & 0xff;
  out[offset + 3] = (value >> 24) & 0xff;
}

function makeBybNotesTemplate() {
  const bin = atob(BYB_NOTES_TEMPLATE_BASE64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) out[i] = bin.charCodeAt(i);
  return out.length === 3250 ? out : new Uint8Array(3250);
}

function makeBybFooter(frameCount, options = {}) {
  const footer = new Uint8Array(FRAME_SIZE + 3250);
  writeUInt32LE(footer, 0, frameCount + 1);
  footer.set(makeBybNotesTemplate(), FRAME_SIZE);

  const front = options.frontConfig || {};
  const rear = options.rearConfig || {};
  const notesOffset = FRAME_SIZE;
  const fields = [
    [notesOffset + 320, front.suspensionTravel ?? options.frontSuspensionTravel ?? 200],
    [notesOffset + 330, rear.suspensionTravel ?? options.rearSuspensionTravel ?? options.rearShockTravel ?? 200],
    [notesOffset + 360, front.wheelTravel ?? options.frontWheelTravel ?? 200],
    [notesOffset + 370, rear.wheelTravel ?? options.rearWheelTravel ?? 200],
    [notesOffset + 400, front.sensorLength ?? options.frontSensorLength ?? 225],
    [notesOffset + 410, rear.sensorLength ?? options.rearSensorLength ?? 85],
    [notesOffset + 440, front.wheelSize ?? options.frontWheelSize ?? 29],
    [notesOffset + 450, rear.wheelSize ?? options.rearWheelSize ?? 27.5],
  ];

  for (const [offset, value] of fields) writeAsciiBytes(footer, offset, String(value), 10);
  return footer;
}

export function encodeRowFrame(row, seq, rearOffset) {
  const frame = new Uint8Array(FRAME_SIZE);
  const view = new DataView(frame.buffer);
  view.setUint32(0, seq, true);

  const susp1 = toNumber(
    pick(row, ['front_disp', 'Susp1', 'Fork', 'front', 'front_mm', 'fork']),
    0,
  );
  const susp2 = toNumber(
    pick(row, ['rear_disp', 'Susp2', 'Shock', 'rear', 'rear_mm', 'shock']),
    0,
  );
  const rawSuspFront = susp1 <= 1.2 ? susp1 * 4095 : susp1;
  const rawSuspRear = susp2 <= 1.2 ? susp2 * 4095 : susp2;

  view.setUint16(4, clampUInt16(rawSuspFront), true);
  view.setUint16(6, clampUInt16(rawSuspRear), true);

  for (let i = 0; i < DEFAULT_LABEL_WORDS.length; i += 1) {
    view.setUint16(8 + i * 2, DEFAULT_LABEL_WORDS[i], true);
  }

  const brake1 = toNumber(pick(row, ['Brake1', 'Fbrake', 'fbrake', 'front_brake']), 0);
  const brake2 = toNumber(pick(row, ['Brake2', 'Rbrake', 'rbrake', 'rear_brake']), 0);
  const gx = toNumber(pick(row, ['GyroX', 'gyro_x', 'gyro_frame_x']), 0);
  const gy = toNumber(pick(row, ['GyroY', 'gyro_y', 'gyro_frame_y']), 0);
  const gz = toNumber(pick(row, ['GyroZ', 'gyro_z', 'gyro_frame_z']), 0);
  const ax = toNumber(pick(row, ['AccX', 'acc_x', 'acc_frame_x', 'accel_x']), 0);

  view.setInt16(20, clampInt16(brake1 * 2), true);
  view.setInt16(22, clampInt16(brake2 + rearOffset), true);
  view.setInt16(24, clampInt16(ax * 2048), true);
  view.setInt16(26, clampInt16((gx - GYRO_BIAS.x) / GYRO_SCALE.x), true);
  view.setInt16(28, clampInt16((gy - GYRO_BIAS.y) / GYRO_SCALE.y), true);
  view.setInt16(30, clampInt16((gz - GYRO_BIAS.z) / GYRO_SCALE.z), true);

  const lat = toNumber(pick(row, ['Latitude', 'lat', 'gps_lat']), 0);
  const lon = toNumber(pick(row, ['Longitude', 'lon', 'gps_long']), 0);
  const alt = toNumber(pick(row, ['Altitude', 'altitude', 'gps_alt', 'elevation']), 0);
  const gpsSpeed = toNumber(pick(row, ['gpsSpeed', 'gps_speed', 'Speed1', 'Speed', 'speed']), 0);

  view.setInt32(32, clampInt32(lat * 1e7), true);
  view.setInt32(36, clampInt32(lon * 1e7), true);
  view.setFloat32(40, alt, true);
  view.setFloat32(44, gpsSpeed, true);
  view.setUint16(48, 0xffff, true);
  view.setUint16(50, 0x0000, true);

  return frame;
}

/**
 * @param {object[]} samples - RideView telemetry rows (normalized field names).
 * @param {{ rearOffset?: number, templateHeader?: Uint8Array }} [options]
 * @returns {ArrayBuffer}
 */
export function encodeTelemetrySamplesToBybArrayBuffer(samples, options = {}) {
  const rearOffset = options.rearOffset ?? 1724;
  const templateHeader = options.templateHeader;

  if (!Array.isArray(samples) || samples.length === 0) {
    throw new Error('No telemetry samples to export.');
  }

  const rows = resampleRowsToBybRate(samples.map(telemetrySampleToBybExportRow));
  const header = makeBybHeaderBuffer(rows, templateHeader);
  const footer = makeBybFooter(rows.length, options);
  const totalLen = BYB_HEADER_SIZE + rows.length * FRAME_SIZE + footer.length;
  const out = new Uint8Array(totalLen);
  out.set(header, 0);

  let offset = BYB_HEADER_SIZE;
  for (let i = 0; i < rows.length; i += 1) {
    const frame = encodeRowFrame(rows[i], i + 1, rearOffset);
    out.set(frame, offset);
    offset += FRAME_SIZE;
  }
  out.set(footer, offset);

  return out.buffer.slice(out.byteOffset, out.byteOffset + out.byteLength);
}

export function validateBybArrayBufferForDownload(buffer) {
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  const magic = new TextDecoder('ascii').decode(bytes.slice(0, MAGIC.length));
  if (magic !== MAGIC) return { ok: false, error: `Invalid BYB header (${magic || 'empty'}).` };

  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  let offset = BYB_HEADER_SIZE;
  let expectedSeq = 1;
  while (offset + FRAME_SIZE <= bytes.length && view.getUint32(offset, true) === expectedSeq) {
    expectedSeq += 1;
    offset += FRAME_SIZE;
  }
  const notesStart = offset;
  if (bytes.length - notesStart !== 3250) {
    return { ok: false, error: `Invalid BYB notes block length (${bytes.length - notesStart}).` };
  }
  const readField = (rel) => new TextDecoder('ascii').decode(bytes.slice(notesStart + rel, notesStart + rel + 10)).replace(/\0.*$/, '');
  const required = [320, 330, 360, 370, 400, 410, 440, 450].map(readField);
  if (required.some((value) => !value || value === '0')) {
    return { ok: false, error: `Invalid BYB notes fields (${required.join(', ')}).` };
  }
  return { ok: true, frameCount: expectedSeq - 2, notesStart };
}

/** Column names match RideView BYB CSV import (Fork, Fbrake, …). */
const BYB_APP_CSV_HEADERS = [
  'Time',
  'Fork',
  'Shock',
  'Fbrake',
  'Rbrake',
  'Speed',
  'AccX',
  'AccY',
  'AccZ',
  'GyroX',
  'GyroY',
  'GyroZ',
  'Latitude',
  'Longitude',
  'Altitude',
  'gpsSpeed',
];

function escapeBybCsvCell(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number' && !Number.isFinite(value)) return '';
  const s = typeof value === 'number' ? String(value) : String(value).trim();
  if (!s) return '';
  if (/[;"\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Semicolon-separated BYB-style CSV (same shape RideView imports as BYB).
 * @param {object[]} samples
 * @param {string} [delimiter]
 * @returns {string}
 */
export function encodeTelemetrySamplesToBybCsvText(samples, delimiter = ';') {
  if (!Array.isArray(samples) || samples.length === 0) {
    throw new Error('No telemetry samples to export.');
  }
  const lines = [BYB_APP_CSV_HEADERS.join(delimiter)];
  for (let i = 0; i < samples.length; i += 1) {
    const s = samples[i] || {};
    const gpsSpd = s.gps_speed != null && Number.isFinite(Number(s.gps_speed)) ? s.gps_speed : s.speed;
    const row = [
      s.time,
      s.fork,
      s.shock,
      s.front_brake,
      s.rear_brake,
      s.speed,
      s.accel_x,
      s.accel_y,
      s.accel_z,
      s.gyro_x,
      s.gyro_y,
      s.gyro_z,
      s.lat,
      s.lon,
      s.elevation,
      gpsSpd,
    ];
    lines.push(row.map(escapeBybCsvCell).join(delimiter));
  }
  return `${lines.join('\n')}\n`;
}

export function sanitizeFilenameBase(name) {
  const s = String(name || 'run').trim() || 'run';
  return s.replace(/[/\\?%*:|"<>]/g, '_').slice(0, 120);
}
